import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Legacy single-asset map view (droidmap#2591). Every raster now opens in the
 * advanced map — layer stack, basemap picker, measure/analyze/annotate tools —
 * so this route only survives to keep existing links and bookmarks working:
 * it resolves the asset's set and forwards to `map-advanced`, carrying the
 * asset id so the advanced map lands on the same raster the old view showed.
 */
export const Route = createFileRoute(
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/assets_/$assetId_/map',
)({
  loader: async ({ params, context }) => {
    const { orgId, projectId, assetId } = params
    const { assetClient } = context.client
    const { metadata } = context

    // Callers of this route never needed the asset set — the simple map keyed
    // off the asset alone — so some passed `_` as a placeholder segment. The
    // advanced map is per-set, so resolve the real one from the asset.
    let assetSetId = params.assetSetId
    if (!assetSetId || assetSetId === '_') {
      const asset = await assetClient.getAsset({ assetId }, metadata)
      assetSetId = asset.assetSetId
    }

    throw redirect({
      to: '/orgs/$orgId/projects/$projectId/asset-sets/$assetSetId/map-advanced',
      params: { orgId, projectId, assetSetId },
      search: { asset: assetId },
      replace: true,
    })
  },
})
